import { createResourceActions } from '../@common/actions/resource-actions';
import { GROUPS_PREFIX } from './constants';

export const groupsActions = createResourceActions(GROUPS_PREFIX);
